export enum LocationElements {
  ID = 'id',
  JOBSITE = 'jobsite',
  POINT_OF_DELIVERY = 'pointOfDelivery',
  PURCHASE_ORDER = 'purchaseOrder',
  RECEIVING_PERSON = 'receivingPerson',
  SPECIAL_INSTRUCTION = 'specialInstructions',
  HAULER = 'hauler',
  ANTICIPATED_INVOICE = 'anticipatedInvoice',
  ADD_NEW_CONTACT = 'addNewContact',

  SHIPPING_CONDITION = 'shippingCondition',
  BUSINESS_LINE = 'businessLine',
  INTERNAL_COMMENTS = 'internalComments',
  DELIVERY_METHOD = 'deliveryMethod',
  DELIVERY_ADDRESS_VIEW_MAP = 'deliveryAddressViewMap',
}
